<div class="sidebar">
	<app-sidebar-header [title]="'extrasSidebar.danishFund.title.danishGuaranteeFund' | ibeadmin | async" [label]="(pricePerPassenger + currency | indracurrency) + ' ' + ('extrasSidebar.danishFund.label.perPassenger' | ibeadmin | async)"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable low-contrast sidebar--danish-offer" #sidebar__body
		style="height: calc(100% - 60px); overflow: auto">

		<div class="sidebar--danish-offer__image">
			<img src="./assets/images/ancillaries/offers/danish-guarantee-fund.svg" [alt]="'extrasSidebar.danishFund.alt.danishFundImg' | ibeadmin | async">
		</div>

		<p>{{ 'extrasSidebar.danishFund.text.danishLaw' | ibeadmin | async }}</p><br>
		<p>{{ 'extrasSidebar.danishFund.text.insolvencyInsurance' | ibeadmin | async }}</p>

		<a class="sidebar--danish-offer__link link link--external" target="_blank" [attr.aria-label]="'extrasSidebar.danishFund.aria.danishFundDetails' | ibeadmin | async" href="https://www.rejsegarantifonden.dk/forside/" role="button">Danish guarantee fund details</a>

		<div class="sidebar--danish-offer__price">
			{{ 'extrasSidebar.danishFund.text.totalForAllPassengers' | ibeadmin | async }}
			<span>{{ danishGuaranteeFund.totalPrice + currency | indracurrency }}</span>
		</div>

		<div actions *ngIf="!hasDanishFund">
			<button class="button" (click)="INDRA_danishGuaranteeFundChanged()" [attr.aria-label]="'extrasSidebar.danishFund.aria.confirmChanges' | ibeadmin | async">{{ 'extrasSidebar.danishFund.label.addDanishFund' | ibeadmin | async }}</button>
		</div>

		<div class="sidebar-flight-text" *ngIf="hasDanishFund && !isModificationDisallowed">
			<button class="button button-main-line" (click)="INDRA_danishGuaranteeFundChanged()" [attr.aria-label]="'extrasSidebar.danishFund.aria.removeDanishFund' | ibeadmin | async">
				{{ 'extrasSidebar.danishFund.label.removeDanishFund' | ibeadmin | async }}
			</button>
		</div>

		<app-notification [style]="'error'" [title]="''" *ngIf="showAddError">
			<div message>
				{{ 'extrasSidebar.danishFund.text.couldNotAddDanishFund' | ibeadmin | async }}
			</div>
		</app-notification> <br>

		<app-notification [style]="'error'" [title]="''" *ngIf="showRemoveError">
			<div message>
				{{ 'extrasSidebar.danishFund.text.couldNotRemoveDanishFund' | ibeadmin | async }}
			</div>
		</app-notification> <br>

		<div class="sidebar-flight-text border-top">
			<p><a class="link extras-feature__link" [attr.aria-label]="'extrasSidebar.danishFund.aria.closeDialog' | ibeadmin | async" (click)="INDRA_handleClose()" href="javascript:;"
					role="button">{{ 'extrasSidebar.danishFund.label.closeThisWindow' | ibeadmin | async }}</a></p>
		</div>

	</div>
</div>
